import { Card, CardBody } from 'reactstrap'
import { useNavigate } from "react-router-dom";
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import { ProjectIconBackgroundColor } from '../../../constants/ProjectIconBackgroundColor';
import { ProjectStatusColor } from '../../../constants/StatusColor';
import { withTranslation } from 'react-i18next';

function ProjectComponent({ projectDetail, t }) {
    const navigate = useNavigate()

    return (
        <div className='singleProjectCard mb-3'>
            <Card>
                <CardBody>
                    <div
                        onClick={() => navigate(`/project/${projectDetail.id}/details`, { id: projectDetail.id })}
                        className="d-flex justify-content-between align-items-center"
                        style={{ cursor: "pointer" }}
                    >
                        <div className="d-flex align-items-center">
                            <div
                                className="iconbox d-inline-block d-flex align-items-center justify-content-center text-white"
                                style={{ fontSize: "20px", backgroundColor: ProjectIconBackgroundColor(projectDetail?.color) }}
                            >
                                {/* <i className=" las la-file-alt"></i> */}
                                <PostAddOutlinedIcon style={{ color: projectDetail?.color ?? '#316BE8' }} />
                            </div>
                            <h5 className="mb-0 ms-3" title={projectDetail.label}>{projectDetail.label}</h5>
                        </div>
                        <div className="d-flex align-items-center">
                            <h6
                                className={`statusBadge ${ProjectStatusColor(projectDetail.status)} justify-content-end mb-0 ms-3 `}
                                style={{ fontSize: "12px" }}
                            >{t(projectDetail.status)}</h6>
                            <i className="las la-angle-right"></i>
                        </div>
                    </div>
                </CardBody>
            </Card>
        </div>
    )
}
export default withTranslation()(ProjectComponent);